import { render, staticRenderFns } from "./ChecklistImport.vue?vue&type=template&id=fde47da0&scoped=true&"
import script from "./ChecklistImport.vue?vue&type=script&lang=ts&"
export * from "./ChecklistImport.vue?vue&type=script&lang=ts&"
import style0 from "./ChecklistImport.vue?vue&type=style&index=0&id=fde47da0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde47da0",
  null
  
)

export default component.exports